/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Deselect_To_PickInputs */



/**
* | output |
* | --- |
* | "Deselect to pick individual files" |
*
* @param {Project_References_Deselect_To_PickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_deselect_to_pick = /** @type {((inputs?: Project_References_Deselect_To_PickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Deselect_To_PickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abwählen, um einzelne Dateien auszuwählen")
	return /** @type {LocalizedString} */ ("Deselect to pick individual files")
});